/**
 * @description 随机相关
 * @created 2024/04/19 15:38:39
 */

/**
 * @description 随机字符串（字母+数字）
 * @created 2024/04/19 15:39:01
 */
export function randomString(letterLength, numberLength, connector = "*") {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
  const numbers = "0123456789"
  let result = ""

  for (let i = 0; i < letterLength; i++) {
    const randomIndex = Math.floor(Math.random() * letters.length)
    result += letters.charAt(randomIndex)
  }

  result += connector

  for (let i = 0; i < numberLength; i++) {
    const randomIndex = Math.floor(Math.random() * numbers.length)
    result += numbers.charAt(randomIndex)
  }

  return result
}

/**
 * @description 随机数字数组
 * @created 2024/04/19 15:41:17
 */
export function randomNumberArray(min, max, length = 50) {
  const list = []
  for (let i = 0; i < length; i++) {
    list.push(Number((Math.random() * (max - min) + min).toFixed(1)))
  }
  return list
}
